type Content = { [key: string]: Content | React.ReactNode };

// https://www.totaltypescript.com/iterate-over-object-keys-in-typescript
function isKey<T extends Content | React.ReactNode>(x: T, k: PropertyKey): k is keyof T {
  return (x && k in x) || false;
}
/**
 * maps content with the proper locale
 *
 * @param {Content} contentMap - a content object with per locale strings / JSX.Elements
 * @param {string} translationKey - key of the locale to display
 * @param {string} [fallbackTranslationKey='US'] - default key in case the content doesn't exist on the desired locale
 *
 * @returns {(path: string) => React.ReactNode } t - translation mapping function
 */
export const createTranslationFn =
  (contentMap: Content, translationKey: string, fallbackTranslationKey: string = 'US') =>
  (path: string) => {
    const pathKeys = path.split('.');
    let currNode = contentMap[translationKey];
    let defaultCurrNode = contentMap[fallbackTranslationKey];
    pathKeys.forEach((pathKey) => {
      defaultCurrNode =
        defaultCurrNode && isKey(defaultCurrNode, pathKey) ? defaultCurrNode[pathKey] : '';
      currNode = currNode && isKey(currNode, pathKey) ? currNode[pathKey] : defaultCurrNode;
    });
    return currNode as React.ReactNode;
  };
